module.exports = __webpack_public_path__ + "static/media/bm-ortofoto2000.8fbd5c22.png";